// src/Tabs.tsx

import React, { useState, useEffect, ReactNode } from 'react';
interface TabsProps {
  children: ReactNode;
  className?: string;
  listClassName?: string;
  contentClassName?: string;
  defaultActiveKey?: string;
  onTabChange?: (activeTab: string) => void;
  tabsDefaultState?: boolean;
}

const Tabs: React.FC<TabsProps> = ({ children, className, defaultActiveKey, contentClassName, listClassName, onTabChange, tabsDefaultState = false }) => {

  const handleClick = (index: number) => {
    setActiveTab(index);
    if (onTabChange) {
      onTabChange(getKeyByIndex(index));
    }
  };

  const getIndexByKey = (key: string) => {
    let defaultIndex;
    React.Children.map(children, (child, index) => {
      if (React.isValidElement(child) && key === child.props?.eventKey) {
        defaultIndex = index;
      }
    })
    return defaultIndex;
  }

  const getKeyByIndex = (index: number) => {
    let defaultKey = '';
    React.Children.map(children, (child, i) => {
      if (React.isValidElement(child) && i === index) {
        defaultKey = child.props?.eventKey;
      }
    });
    return defaultKey ?? '';
  }

  const [activeTab, setActiveTab] = useState(
    defaultActiveKey ? getIndexByKey(defaultActiveKey) :
    0
  );
  const [defaultTab, setDefaultTab] = useState<string | null>(defaultActiveKey ?? null);

  useEffect(() => {
    const updateActiveKey = (newActiveTab: string) => {
      setActiveTab(getIndexByKey(newActiveTab));
      setDefaultTab(newActiveTab);
    }
    if (defaultActiveKey?.length && (defaultTab !== defaultActiveKey || tabsDefaultState)) {
      updateActiveKey(defaultActiveKey);
    }
  }), [defaultActiveKey, tabsDefaultState];

  return (
    <div className={`tabs ${className ?? ''}`}>
      <div className={`tab-list ${listClassName ?? ''}`}>
        {React.Children.map(children, (child, index) =>
          React.isValidElement(child) ? (
            <button
              className={`tab ${child.props?.className ?? ''} ${activeTab === index ? 'active' : ''}`}
              onClick={() => handleClick(index)}
            >
              <div>{child.props.label}</div>
            </button>
          ) : null
        )}
      </div>
      <div className={`tab-content ${contentClassName ?? ''}`}>
        {React.Children.map(children, (child, index) =>
          React.isValidElement(child) && activeTab === index ? (
            <div className={`tab-panel active`}>
              {child.props.children}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default Tabs;